<template>
    <v-layout column fill-height>
        <Breadcrumbs guia="Sou + Previsul" titulo="Sou + Previsul" :descricao="descricao" :tabs="tabOptions" />

        <v-layout class="main">
          <v-overlay :value="fullLoading">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>   
          <v-dialog v-model="dialogRegulamento" width="1000" height="500" :persistent="false" rounded align-self-center>
            <v-card>
              <v-card-text>
                <object v-if="campanhaRegulamento == 1" data="/upload/sou_mais/regulamento_sou_previsul_tudo_azul.pdf?#zoom=110" type="application/pdf" width="950" height="400">
                  alt : <a href="/upload/sou_mais/regulamento_sou_previsul_tudo_azul.pdf">regulamento_sou_previsul_tudo_azul.pdf</a>
                </object>
                <div v-if="campanhaRegulamento == 2">
                  <object v-if="sorteioRegulamento" data="/upload/sou_mais/regulamento_sou_previsul_sorte_de_campeao.pdf?#zoom=110" type="application/pdf" width="950" height="400">
                    alt : <a href="/upload/sou_mais/regulamento_sou_previsul_sorte_de_campeao.pdf">regulamento_sou_previsul_sorte_de_campeao.pdf</a>
                  </object>
                  <div v-if="!sorteioRegulamento">
                    <v-form ref="formRepresentanteLegal" v-model="representanteValido" enctype="multipart/form-data">
                      <v-row dense>
                        <v-col cols="12">
                          <v-icon color="red">mdi-alert-octagon-outline</v-icon> <strong>Atenção! o preenchimento deverá ser do representante legal do corretor, ou seja, quem consta como representante legal no contrato social.</strong>
                        </v-col>
                      </v-row>                 
                      <v-row dense>
                        <v-col cols="5">
                          <v-text-field tabindex="1" v-model="requisicaoAssinaturaDigital.Email" :rules="[rules.required, rules.Email]" label="A requisição da assinatura digital será enviada ao seginte E-mail :"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          &nbsp;
                        </v-col>
                        <v-col cols="5">
                          <v-text-field tabindex="2" v-model="requisicaoAssinaturaDigital.Nome" :rules="[rules.required, rules.Min]" label="Nome :"></v-text-field>
                        </v-col>                      
                      </v-row>
                      <v-row dense>
                        <v-col cols="5">
                          <v-text-field tabindex="3" v-model="requisicaoAssinaturaDigital.Documento" :rules="[rules.required, rules.CPF]" v-mask="CPFMask" label="CPF :"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          &nbsp;
                        </v-col>                      
                        <v-col cols="5">
                          <v-text-field tabindex="4" v-model="requisicaoAssinaturaDigital.Funcao" :rules="[rules.required, rules.Min]" label="Função/Cargo :"></v-text-field>
                        </v-col>                      
                      </v-row>                          
                    </v-form>              
                  </div>
                </div>    
              </v-card-text>
              <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="campanhaRegulamento == 1" color="info" type="button" @click="AceiteRegulamento">Concordo</v-btn>
                    <v-btn v-if="campanhaRegulamento == 2 && sorteioRegulamento" color="info" type="button" @click="sorteioRegulamento = false;">Enviar/Reenviar solicitação de assinatura</v-btn>
                    <v-btn v-if="campanhaRegulamento == 2 && !sorteioRegulamento" color="info" type="button" tabindex="5" :disabled="!representanteValido" @click="enviarParaAssinaturaDigital">Enviar</v-btn>                  
              </v-card-actions>
            </v-card>
          </v-dialog>        
          <ParticipacaoResultado v-if="campanha == 1" />
          <Sorteio v-if="campanha == 2" />
        </v-layout>        
    </v-layout>
</template>


<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { mask } from 'vue-the-mask';
import Helpers from "@/utilities/Helpers";

import Breadcrumbs from "@/components/portal/layout/Breadcrumbs";
import ParticipacaoResultado from "@/components/portal/sou-mais-previsul/ParticipacaoResultado";
import Sorteio from "@/components/portal/sou-mais-previsul/Sorteio";

export default {
    mixins: [Helpers],
    components: {
        Breadcrumbs,
        ParticipacaoResultado,
        Sorteio
    },
    data () {
      return {
        tab:1,
        guia: "Sou + Previsul > Painel",
        tabOptions: [],
        campanha: 0,
        campanhaRegulamento: 0,
        fullLoading: false,
        corretorNome: "",
        descricao: "",
        aceiteRegulamento : false,
        dialogRegulamento : false,
        regulamentoAssinado : true,
        emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        sorteioRegulamento: true,
        requisicaoAssinaturaDigital: {
          Email: '',
          CodigoCorretor: 0,
          Campanha: 0,
          Nome: '',
          Documento: '',
          Funcao: ''
        },
        CPFMask: '###.###.###-##',
        rules: {
            required: value => !!value || 'Obrigatório',
            Email: value => this.emailPattern.test(value) || 'E-mail inválido',
            Min: value => value.length > 2 || 'Obrigatório',
            CPF: value => value.length >= 11 || 'CPF inválido',
        },
        representanteValido: false,        
      }
    },
    methods: {
      validarCampanha()
      {
        let codigoCorretor = this.usuario.codCorretor;
        let url = "SouMaisPrevisul/campanha/"+ codigoCorretor;
        this.fullLoading = true;  

        if (this.campanha == 0)
        {
          Vue.prototype.$httpPortal.get(url)
          .then(res => {
            this.campanha = parseInt(res.data);

            this.fullLoading = false;
          })
          .catch(ex => {
              console.log(ex);
              this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
              this.fullLoading = false;
          });   
        }
        else
        {
          this.fullLoading = false;
        }
      },
      validarAceiteRegulamento()
      {
        let codigoCorretor = this.usuario.codCorretor;
        let url = "SouMaisPrevisul/regulamento/"+ codigoCorretor;
        this.fullLoading = true;

        Vue.prototype.$httpPortal.get(url)
        .then(res => {
          console.log(url, res.data);
          //{Dashboard: 1, Aceite: false}
          this.campanhaRegulamento = res.data.Dashboard;
          if (res.data.Aceite)
          {
            this.validarCampanha();
          }
          else
          {
            //Mensagem
            if(res.data.AssinaturaDigitalPendente)
            {
              this.showToast("warning", "Atenção", "Requisição de assinatura digital pendente, verifique a caixa de entrada do seu E-mail");
            }
            this.dialogRegulamento = true;
            this.regulamentoAssinado = false;
          }
          this.fullLoading = false;
        })
        .catch(ex => {
            console.log(ex);
            this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
            this.fullLoading = false;
        });         
      },      
      formatPrice(value, fixed = 0) {
          let _arrayValue = value.toString().split('.');
          let _cent = parseInt(_arrayValue[1]);
          if(_cent > 0)
          {
            fixed = 2;
          }
          else
          {
            fixed = 0;
          }

          let val = (value/1).toFixed(fixed).replace('.', ',')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }, 
      AceiteRegulamento()
      {
        let codigoCorretor = this.usuario.codCorretor;
        let url = "SouMaisPrevisul/aceite-regulamento/"+ codigoCorretor+"/"+this.campanhaRegulamento;
        this.dialogRegulamento = false;
        this.fullLoading = true;
        
        if(!this.regulamentoAssinado)
        {
          Vue.prototype.$httpPortal.get(url)
          .then(res => {
            if (res.data)
            {
                this.regulamentoAssinado = true;
                this.validarCampanha();
            }
            else
            {
              this.dialogRegulamento = true;
            }
            this.fullLoading = false;
          })
          .catch(ex => {
              console.log(ex);
              this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
              this.fullLoading = false;
          }); 
        }         
      },
      enviarParaAssinaturaDigital()
      {
        if(this.representanteValido)
        {
          let codigoCorretor = this.usuario.codCorretor;
          let url = "SouMaisPrevisul/corretor/enviar-assinatura-digital";

          this.requisicaoAssinaturaDigital.CodigoCorretor = codigoCorretor;
          this.requisicaoAssinaturaDigital.Campanha = this.campanhaRegulamento;

          this.dialogRegulamento = false;
          this.fullLoading = true;
          
          if(!this.regulamentoAssinado)
          {
            Vue.prototype.$httpPortal.post(url, this.requisicaoAssinaturaDigital)
            .then(res => {
              if (res.data)
              {
                  this.showToast("success", "Sucesso", `A requisição de assinatura digital foi enviada para o E-mail : ${this.requisicaoAssinaturaDigital.Email} verifique a caixa de entrada`);
              }
              this.sorteioRegulamento = true;
              //this.dialogRegulamento = true;
              this.fullLoading = false;
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.dialogRegulamento = true;
                this.fullLoading = false;
            }); 
          }            
        }
      }           
    },
    created(){
        let _corretorNomeArray = this.usuario.nome.trim().split(' ');
        if (_corretorNomeArray[0] !== undefined)
        {
            this.corretorNome = _corretorNomeArray[0];
        }
        if (_corretorNomeArray[1] !== undefined)
        {
            this.corretorNome += ' '+ _corretorNomeArray[1];
        }
        
        if(this.corretorNome.length == 0)
        {
            this.corretorNome = "Corretor";
        }
        this.descricao = 'Bem-vindo(a) de volta. Realize mais vendas novas e aumente suas chances de ganhar!';
    },    
  computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
  },    
  mounted()
  {
    //this.validarCampanha();
    this.requisicaoAssinaturaDigital.Email = this.usuario.email;
    console.log("usuário", this.usuario);
    this.validarAceiteRegulamento();
    //regulamento_sou_previsul_tudo_azul.pdf
  }
  }
</script>
<style>
.btn-texto .v-btn__content
{
    font-weight: bold;
}

.btn-texto .v-btn__content:hover
{
    text-decoration: underline;
}
.dialog-titulo {
    font-style: normal;
    font-weight: bold;
    font-size: 27px;
}
.dialog-sub-titulo {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
}

.v-carousel__controls__item
{
    color: #CFCFCF !important;
}
.v-item--active
{
    color: #808080 !important;
}

.imagem-borrada
{
  filter: blur(5px);
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
}

.break-word 
{
  word-break: break-word !important;
}

.box-with-link a {
    font-weight: bold;
    color:#F57E27;
}

.box-with-link a:hover {
    text-decoration: underline;
}

 .generic-link {
    font-weight: bold;
}
 .generic-link:hover {
    text-decoration: underline;
}
.card-hover .inner-hover
{
  font-weight: bold;
}

.card-hover:hover .inner-hover {
    text-decoration: underline;
}

</style>

